import React from 'react'
import { useForm } from '../../forms/hocs/form.context'
import { StyledSearchFacetSectionCountAndSave } from './search-facets.styles'
import { SearchCountAndAdsDisclaimerContainer } from '../../components/search-count-and-ads-disclaimer/search-count-and-ads-disclaimer'
import { SaveSearch } from '../saved-searches/save-search'

export const ResultsCountAndSaveSearchSection = () => {
    const { totalResults, sortByDisplayTooltip } = useForm()

    return (
        <StyledSearchFacetSectionCountAndSave>
            <SearchCountAndAdsDisclaimerContainer
                totalResults={totalResults}
                sortDescription={sortByDisplayTooltip}
                position={'left'}
            />
            <div data-testid="saved-search-action-area">
                <SaveSearch />
            </div>
        </StyledSearchFacetSectionCountAndSave>
    )
}
